import { configConstants as doms } from "../../../constants/configs";

const initialState = { loading: true, list: [], specialite: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case doms.GET_SPECIALITES:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case doms.GET_SPECIALITE:
      return {
        ...state,
        loading: false,
        domaine: payload,
      };
    default:
      return state;
  }
}
